export default "__VITE_ASSET__BntoJ9rR__"